module.exports = __webpack_public_path__ + "img/annotation-help.6ec1ca7b.svg";